export function sortDesc(a: number, b: number) {
  return b - a;
};

export function log(_args?: any) {
  console.log(`[${window.name}]`, ...arguments);
}

export function stringify(obj: object): string {
  const params = new URLSearchParams();

  Object.keys(obj).forEach(k => {
    params.set(k, obj[k]);
  });

  return params.toString();
}

export function isIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}
